<div class="d-f jc-sb ai-c w-100 header">
	<div class="d-f ai-c ml-quark left">
		<button mat-icon-button aria-label="Toggle menu" (click)="action.emit()">
			<mat-icon svgIcon="sanus-menu"></mat-icon>
		</button>
		<div>
			<a routerLink="/inicio">
				<img class="logo" src="../../assets/images/logo_sanus.svg" alt="logo" />
			</a>
		</div>

		<div class="separator no-mob"></div>

		<div
			class="d-f jc-sb ai-c org-filter no-mob"
			*ngIf="showOrganizationFilter"
			(click)="onOrganizationsFilterOpen()"
		>
			<span class="fs-xs lh-md fw-bold org-name">{{ organization }}</span>
			<img
				src="../../../assets/icons/sanus-chevron-b-down.svg"
				alt=""
				[ngClass]="{ rotate: showOrganizationList }"
			/>
		</div>
	</div>

	<div class="d-f jc-sb right">
		<div class="pos-r d-f ai-c mr-xxs c-p" (click)="onShowNotifications()">
			<mat-icon
				svgIcon="sanus-bell"
				matBadgeColor="warn"
				[matBadge]="notificationsCount"
				*ngIf="notificationsCount && notificationsCount > 0"
			></mat-icon>
			<mat-icon
				svgIcon="sanus-bell"
				*ngIf="!notificationsCount || notificationsCount < 0"
			></mat-icon>
			<mat-icon
				svgIcon="sanus-alert-gray"
				class="badge-alert"
				*ngIf="notificationsCount === -1"
			></mat-icon>
		</div>
		<div class="d-f ai-c c-p" (click)="showDialog = true">
			<p class="mr-nano pt-quark fs-xxs fw-bold name-label">
				{{ session ? session.name : '' }}
			</p>
			<div class="d-f jc-c ai-c mr-sm pt-quark br-circular user">
				{{ formatName() | uppercase }}
			</div>
		</div>
	</div>
</div>

<div class="d-f jc-sb ai-c w-100 subheader">
	<div
		class="d-f jc-sb ai-fe org-filter"
		*ngIf="showOrganizationFilter"
		(click)="onOrganizationsFilterOpen()"
	>
		<span class="fs-xxs lh-sm fw-bold org-name">{{ organization }}</span>
		<img
			src="../../../assets/icons/sanus-chevron-b-down.svg"
			alt=""
			[ngClass]="{ rotate: showOrganizationList }"
		/>
	</div>
</div>

<ng-container *ngIf="showOrganizationList">
	<div class="org-list">
		<div class="search-form" [formGroup]="searchForm">
			<mat-form-field
				class="mr-xxxs search-field"
				title="Busca de organizações"
				appearance="outline"
			>
				<mat-label>Pesquisar</mat-label>
				<input
					id="sms-sro"
					type="text"
					matInput
					placeholder="Pesquisar"
					formControlName="term"
					(keyup)="onSearchKeyUp($event)"
					(input)="onSearch()"
				/>
			</mat-form-field>
		</div>
		<ng-container
			*ngFor="let organization of organizations; let organizationIndex = index"
		>
			<div
				class="list-item"
				*ngIf="organizationIndex < limit"
				(click)="
					onOrganizationSelect(organization.id, organization.name_secondary)
				"
			>
				<div
					class="d-f fd-c jc-c ml-nano fav"
					(click)="
						onToggleFavorite($event, organization.id, organization.isFavorite)
					"
				>
					<img
						alt=""
						src="../../../assets/icons/sanus-fav-{{
							organization.isFavorite ? 'on' : 'off'
						}}.svg"
					/>
				</div>
				<p class="to-ellipsis">
					{{ organization.name_secondary }}
				</p>
			</div>
		</ng-container>
		<ng-container class="list-item" *ngIf="organizations.length === 0">
			<p class="default-message">Nenhuma organização encontrada</p>
		</ng-container>
		<div class="d-f jc-c ai-c c-p ec-btn" (click)="onToggleListCount()">
			Ver {{ limit === 5 ? 'mais' : 'menos' }}
		</div>
	</div>
	<div class="filter-backdrop" (click)="onCloseFilterList()"></div>
</ng-container>

<div
	class="pos-a w-100 h-full dialog-backdrop"
	(click)="showDialog = false"
	*ngIf="showDialog"
></div>
<div class="pos-a mt-xxxs br-md header-dialog" *ngIf="showDialog">
	<div class="d-f ai-c w-100 mb-xxxs">
		<div
			class="d-f jc-c ai-c mt-xxxs ml-xxxs pt-quark br-circular fs-lg user lg"
		>
			{{ formatName() | uppercase }}
		</div>
		<div class="d-f fd-c ml-nano names">
			<span class="mt-xxxs mb-xxxs fs-xs lh-xs fw-bold to-ellipsis">
				{{ session?.name }}
			</span>
			<span class="fs-xxs lh-xs to-ellipsis mail">{{ session?.email }}</span>
		</div>
	</div>
	<div class="d-f fd-c w-100">
		<div class="d-f ai-c ml-xs c-p item" (click)="config.emit()">
			<mat-icon svgIcon="sanus-cog"></mat-icon>
			<span class="ml-nano fs-xs lh-xs">Configuração</span>
		</div>
		<div class="d-f ai-c ml-xs c-p item" (click)="logout.emit()">
			<mat-icon svgIcon="sanus-exit"></mat-icon>
			<span class="ml-nano fs-xs lh-xs">Sair</span>
		</div>
	</div>
	<div class="d-f jc-c ai-c low-panel">
		<a class="c-p fs-xxxs fw-medium link" (click)="onNavigate('termos-de-uso')">
			Termos de uso
		</a>
		<span>&nbsp;|&nbsp;</span>
		<a
			class="c-p fs-xxxs fw-medium link"
			(click)="onNavigate('politica-de-privacidade')"
		>
			Política de privacidade
		</a>
	</div>
</div>
